<template>
	<div>
		<div>
			<div class="tab-menus d-flex">
				<div class="tab-menu" :class="{ 'active': tab === 'profile' }"
					@click="backToSetting">
					{{ $t('Profile') }}
				</div>
				<div v-if="user.roles[3] !== ('o') && !isFinance" class="tab-menu"
					:class="{ 'active': tab === 'subscription' || tab === 'payment' || tab === 'subs_details' }"
					@click="backToSubs">
					{{ $t('Subscription') }}
				</div>
				<!-- <div
					class="tab-menu"
					:class="{ 'active': tab === 'payment' }"
					@click="setTab('payment')">
					{{ $t('Payment') }}
				</div> -->
				<div v-if="!isFinance" class="tab-menu" :class="{ 'active': tab === 'general' }"
					@click="setTab('general')">
					{{ $t('Settings') }}
				</div>
			</div>
			<div class="tab-contents">
				<!-- Profile -->
				<div class="tab-content" v-if="tab === 'profile'">
					<div v-if="picture" class="profile-picture mb-3">
						<clazy-load class="profile-picture mb-3" alt="Grafias" :src="picture">
							<!-- The image slot renders after the image loads. -->
							<img class="profile-picture mb-3" alt="Grafias" :src="picture">
							<!-- The placeholder slot displays while the image is loading. -->
							<div slot="placeholder">
								<!-- You can put any component you want in here. -->
								<img class="profile-picture mb-3" alt="Grafias" :src="'/img/Rolling-1s-90px.svg'">
							</div>
						</clazy-load>
					</div>
					<!-- <img :src="picture" class="profile-picture mb-3" alt="Grafias"
						> -->
					<img :src="defaultPictureProfile" class="profile-picture mb-3" alt="Grafias"
						v-if="!picture">
					<div>
						<label
							class="btn btn-default btn-icon mr-3 mb-0 inline-block btn-edit-picture"
							v-tooltip="'Change Profile Picture'">
							<i class="material-icons md-18 mr-0">edit</i>
							<input type="file" class="hidden" @change="onSelectPicture" accept=".png,.gif,.jpeg,.jpg"/>
						</label>
						<button role="button"
							class="btn btn-default btn-icon inline-block btn-remove-picture"
							:class="{ 'is-loading': isRemovingPicture }"
							v-tooltip="'Remove Profile Picture'" @click="confirmRemovePicture">
							<i class="material-icons md-18">delete</i>
						</button>
						<button role="button"
							class="btn btn-default btn-icon inline-block btn-remove-picture ml-2"
							:class="{ 'is-loading': isChangePassword }"
							v-tooltip="'Change Password'" @click="isFormPasswordVisible = true">
							<i class="material-icons md-18">lock</i>
						</button>
					</div>

					<div class="mt-5" v-if="user">
						<div v-if="!isEdit">
							<div class="form-group">
								<label class="mb-0">{{ $t('Fullname') }}</label>
								<div>{{ user.name }}</div>
							</div>
							<div class="form-group">
								<label class="mb-0">{{ $t('Email') }}</label>
								<div>{{ user.email }}</div>
							</div>
							<div class="form-group">
								<label class="mb-0">{{ $t('Phone') }}</label>
								<div>{{ user.phone }}</div>
							</div>
							<div class="form-group">
								<label class="mb-0">{{ $t('Timezone') }}</label>
								<div>{{ timezoneLabel }}</div>
							</div>
							<!-- <div class="form-group">
								<label class="mb-0">{{ $t('Language') }}</label>
								<div>{{ languageLabel }}</div>
							</div> -->
							<button type="button" class="btn btn-primary mt-3 mr-3" @click="edit">
								{{ $t('Edit My Profile') }}
							</button>
							<button v-if="user && !user.roles.includes('client')" type="button" class="btn btn-primary mt-3" @click="isShowMoreFeature = true">
								{{ $t('More Features') }}
							</button>
						</div>
						<!-- Edit -->
						<form class="edit-profile-form" @submit.prevent="updateProfile"
							v-if="isEdit">
							<div class="form-group">
								<label class="mb-0">{{ $t('Fullname') }}</label>
								<input type="text" class="form-control" v-model="name" required>
							</div>
							<div class="form-group">
								<label class="mb-0">{{ $t('Email') }}</label>
								<input type="text" class="form-control" v-model="email" required>
								<span v-if="!isValidEmailAddress && email !== ''" class="text-danger text-small">{{$t('Invalid Email Address')}}</span>
							</div>
							<div class="form-group">
								<label class="mb-0">{{ $t('Phone') }}</label>
								<input type="number" class="form-control" v-model="phone" required>
							</div>
							<div class="form-group">
								<label class="mb-0">{{ $t('Timezone') }}</label>
								<select name="timezone" class="form-control" v-model="timezone">
									<option v-for="timezoneOption in timezones"
										:key="timezoneOption.key" :value="timezoneOption.key">
										{{ timezoneOption.label }}
									</option>
								</select>
							</div>
							<!-- <div class="form-group">
								<label class="mb-0">{{ $t('Language') }}</label>
								<select
									name="language"
									class="form-control"
									v-model="language">
									<option
										v-for="languageOption in languages"
										:key="languageOption.key"
										:value="languageOption.key">
										{{ languageOption.label }}
									</option>
								</select>
							</div> -->
							<div class="d-flex mt-5">
								<button type="submit" class="btn btn-primary mr-3"
									:disabled="!isValidEmailAddress || name === ''"
									:class="{ 'is-loading': isSaving }">
									{{ $t('Save Changes') }}
								</button>
								<button type="button" class="btn btn-default ml-auto"
									@click="isEdit = false">
									{{ $t('Cancel') }}
								</button>
							</div>
						</form>
					</div>
				</div>

				<!-- Subscription old -->
				<div class="tab-content" v-if="tab === 'subscription-old'">
					<div class="">
						<div class="mb-2 mt-3">
							<div class="text-blue-grey mb-1">{{ $t('Your current subscription')}}<span v-if="printCurrentSubs() === 'Free'"></span>
								<span v-if="printCurrentSubs() !== 'Free'">
								<span v-if="printLeftDaysSubs !== 1" class="ml-1">({{printLeftDaysSubs}}<span class="m-1">Days Left)</span></span>
								<span v-if="printLeftDaysSubs === 1" class="ml-1">(One Day Left)</span>
								</span>
							</div>
							<h2 class="text-primary mb-4">{{ printCurrentSubs() }}</h2>
						</div>
						<!-- <button @click="showDetails()" class="btn btn-primary btn-detail btn-sm mr-2">{{ $t('Details') }}</button> -->
						<button v-if="printCurrentSubs()!=='Free' && !isEndPeriod" @click="showCancel(ActiveSubscription)" class="btn btn-default btn-sm mt-2">{{ $t('Cancel Subscriptions') }}</button>
						<button v-if="printCurrentSubs()!=='Free' && !isEndPeriod" @click="changePaymentModal" class="btn btn-primary btn-sm mt-2 ml-3">{{ $t('Change Payment') }}</button>
						<span class="text-secondary text-small" v-if="isEndPeriod">We set your subscription to free after your period has ended</span>
					</div>
					<!-- User Subscriptions -->
					<div v-for="(subscription,index) in userSubscriptions" :key="'subs_'+index" class="d-inline-flex">
						<div v-if="!subscription.is_current_active" class="border-subs  mr-2">
							<div class="text-primary mb-2">{{ subscription.package_name }}</div>
							<button @click="switchSubscription(subscription.package_id)" class="btn btn-activate small mr-2">{{ $t('Activate') }}</button>
							<!-- <button @click="showDetails()" class="btn btn-detail small mr-2">{{ $t('Details') }}</button> -->
							<button @click="showCancel(subscription)" class="btn btn-detail btn-sm ">{{ $t('Cancel') }}</button>
						</div>
					</div>
					<!-- View Plans -->
					<div class="view-plans mt-5 pt-5 mb-2">
						<h3>
							{{ $t('Available Plans') }}
						</h3>
						<div class="relative">
							<div class="tri-state-toggle">
								<button @click="filterSubscription('m')" class="tri-state-toggle-button" :class="{'active': activeToggleSubs === 'm'}">
									Month
								</button>
								<button @click="filterSubscription('y')" class="tri-state-toggle-button" :class="{'active': activeToggleSubs === 'y'}">
									Year
								</button>
								<button @click="filterSubscription('c')" class="tri-state-toggle-button" :class="{'active': activeToggleSubs === 'c'}">
									Special
								</button>
							</div>
						</div>
						<div class="mt-4 scroll-x-auto tb-pricing mr-5 mb-3 bg-subs-table">
							<table class="table relative table-striped mb-4 bg-grey-tb " :style="{ width: 180 + (300 * filteredPackage.length) + 'px' }" >
								<thead>
									<tr>
										<th class="bg-main-tb" style="max-width: 180px; width: 180px;">{{ $t('Features') }}</th>
										<th  v-for="(item, index) in filteredPackage" style="max-width: 300px; width: 250px;" :key="'label_'+index" class="text-center">
											<div class="truncate-subs-title" v-if="item && item.name.length > 20" v-tooltip.bottom="item.name">{{ item.name }}</div>
											<div class="truncate-subs-title" v-if="item && item.name.length <= 20">{{ item.name }}</div>
										</th>
									</tr>
								</thead>
								<div class="p-5 text-center absolute" v-if="isFetching">
									<div class="is-loading large"></div>
								</div>
								<tbody>
									<td class="p-0" >
										<div class="pl-4 feature-name" v-for="(item, index) in featureNames"
											:key="'FeatureName_'+index"
											:class="{'bg-grey-tb': index % 2, 'bg-main-tb':index % 2}">
											{{item.feature_name}}
										</div>
										<div class="pl-4 price-per-month mb-5">{{ $t('Price') }}</div>
									</td>
									<td v-for="(item, index) in filteredPackage" :key="'details_'+index"
										class="text-center p-0 relative">
										<div class="divider-non-feature"></div>
										<div v-if="item.type === 'non_feature'" class="package-non-feature-desc">{{ item && item.description ? item.description : '' }}</div>
										<div class="align-middle feature-name"
											:class="{'bg-grey-tb': index % 2,'bg-main-tb':index % 2}"
											v-for="(feature, index) in item.packageFeatures"
											:key="'feature_'+index">
											<!-- condition normalize data storage -->
											<span v-if="index !== 4 && item.type !== 'non_feature' && feature.limit_type !== 'boolean'">{{ feature.limit === 0 ? 'UNLIMITED' : feature.limit  }}</span>
											<span v-if="index === 4 && item.type !== 'non_feature' && feature.limit_type !== 'boolean'">{{ convertDataSize(feature.limit === 0 ? 'UNLIMITED' : feature.limit)  }}</span>
											<!-- render sequence -->
											<span v-if="feature.limit_type === 'boolean' && feature.is_enabled">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="widht: 20px; height: 20px">
													<path fill="#FFA800" d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
												</svg>
											</span>
											<span v-if="feature.limit_type === 'boolean' && !feature.is_enabled">-</span>
										</div>
										<h5 class="align-middle price-subs price-info-subs">
											<span v-if="item.price !== 0">${{ commaFormatted(item.price) }}<span v-if="!getPeriod(item).includes('days') && !getPeriod(item).includes('months')"> / </span><span class="text-primary"> {{getPeriod(item)}}</span></span></h5>
										<div class="align-middle p-0 w-100 pl-1 upgrade-btn-subs buy-button-subs">
											<button v-if="item.name !== 'Free' && item.id !== ActiveSubscriptionId" type="button"
												class="btn btn-lg btn-primary w-100 "
												@click="showPayment(item)">{{ $t('Buy Now') }}
											</button>
											<button v-if="item.id === ActiveSubscriptionId" type="button"
												class="btn btn-lg btn-primary w-100 disabled">{{ $t('Current Plan') }}
											</button>
										</div>
									</td>
								</tbody>
							</table>
						</div>
						<div class="tb-pricing">
							You can pause your subscription at any time / one user logged in at the time /
							user will revert back to free, if subscription cancelled!
						</div>
						<!-- form applying coupon from email -->
						<div class="mt-5">
							Enter your coupon here (from email) - for PROMO CODE, you need to use on package purchase
							<div class="ml-0 pl-0 mt-3 d-flex">
								<input v-model="promoCodeFromEmail" type="text" name="promoFromEmail" class="form-control mb-3 w-200px" placeholder="COUPON CODE" v-uppercase>
								<button :class="{'is-loading': isApplyingCoupon}" @click="applyCouponFromEmail()" class="btn btn-primary pl-0 pr-0 ml-3 btn-apply-coupon">Apply Coupon</button>
							</div>
						</div>
						<div class="text-center" v-if="items.length === 0 && !isFetching">{{$t('No data available')}}</div>
					</div>
				</div>

        <div class="tab-content" v-if="tab === 'subscription'">
          <form class="edit-profile-form" @submit.prevent="requestSubs">
              <div class="mb-4">
                <h1 class="text-white">{{ $t('Get in touch') }}</h1>
                <h5 style="white-space: nowrap; font-weight: 400;">{{ $t('Please fill in the form, and thank you for reaching out to us') }}</h5>
              </div>
							<div class="form-group">
								<label class="mb-0">1. {{ $t('Fullname') }}</label>
								<input type="text" class="form-control" v-model="nameSubs" required>
							</div>
							<div class="form-group mt-4">
								<label class="mb-0">2. {{ $t('Email') }}</label>
								<input type="text" class="form-control" v-model="emailSubs" required>
								<span v-if="!isValidSubsEmailAddress && emailSubs !== ''" class="text-danger text-small">{{$t('Invalid Email Address')}}</span>
							</div>
							<div class="form-group mt-4">
								<label class="mb-0">3. {{ $t('How Can we assist you?') }}</label>
                <div class="mt-0 pt-0">
                  <MdRadio class="type-length-package md-primary" v-model="assist" value="Support">{{$t('Support')}}</MdRadio>
                </div>
								<div class="mt-0 pt-0">
                  <MdRadio class="type-length-package md-primary" v-model="assist" value="Subscription">{{$t('Subscription')}}</MdRadio>
                </div>
                <div class="mt-0 pt-0">
                  <MdRadio class="type-length-package md-primary custom" v-model="assist" value="Other">
                    <div>
                      <input :disabled="assist === 'Subscription' || assist === 'Support'"
                      type="text" class="form-control w-100" v-model="assistOther" required>
                    </div>
                  </MdRadio>
                </div>
							</div>
              <div class="form-group mt-4">
								<label class="mb-0">4. {{ $t('You have something to share') }}?</label>
								<textarea type="text" name="notes" rows="6" class="form-control"
                  v-model="notes">
                </textarea>
							</div>
							<div class="d-flex mt-5">
								<button type="submit" class="btn btn-primary mr-3"
									:disabled="!isValidSubsEmailAddress || !nameSubs || !notes || !assist"
									:class="{ 'is-loading': isSaving || isSendingSubs }">
									{{ $t('Send') }}
								</button>
							</div>
						</form>
        </div>

				<!-- Payment -->
				<div class="tab-content col-sm-4 payment-form" v-if="tab === 'payment'">
					<transition name="fade">
						<div>
							<form @submit.prevent="">
								<div class="mb-2">
									<h2 class="font-weight-normal">{{ $t('Payment') }}</h2>
								</div>
								<span>Subscription & payment are handled by </span><span><a href="https://stripe.com" target="_blank">Stripe</a></span>
								<div  class="form-group mt-3">
									<div class="mh-50">
										<input v-model="paymentName" type class="form-control field" placeholder="Name" :class="{'error-input': paymentName === '', 'mb-4': paymentName.length >= 5 || paymentName.length === 0}">
										<span v-if="paymentName.length < 5 && paymentName.length !== 0" class="error-color-input">Please enter a name of at least 5 characters</span>
									</div>
									<input v-model="paymentEmail" type="email" name="email" class="form-control field  mb-3" placeholder="E-mail" :class="{'error-input': paymentEmail === ''}">
									<div class="row">
										<div class="col-sm-9">
											<input v-model="promoCode" :class="{'error-input': (!promoValid && promoCode !=='')}" type="text" name="promo" class="form-control mb-3" placeholder="PROMO CODE" v-uppercase>
										</div>
										<div class="col-sm-3 ml-0 pl-0">
											<button :class="{ 'is-loading': isCheckPromoCode, 'disabled': promoCode === '' }"
											@click="checkPromoCode()" class="btn btn-default h-70 w-100 pl-0 pr-0">Apply Promo</button>
										</div>
									</div>
									<div id="card-element" class="stripe-field"></div>
									<!-- We'll put the error messages in this element -->
									<div id="card-errors" role="alert"></div>
								</div>
								<div class="d-flex justify-content-between">
									<div>
										<button :class="{ 'is-loading': isPaymentSuccess }"
										class="btn btn-primary mb-2 mr-2" @click="checkout(selectedPackage)" :disabled="(!isValidNameAndEmail && isValidCreditCard) || (!promoValid && promoCode !== '')">Pay For {{ selectedPackage && selectedPackage.name ? selectedPackage.name : 'unknown package' }}</button>
									</div>
									<div>
										<button class="btn btn-default mb-2" @click="backToSubs">Cancel</button>
									</div>
								</div>
								<label :class="{'text-red': promoInformation === 'Promo code is unavailable', 'text-yellow': promoInformation === 'You cannot use this promo code for this current package'}"
								v-if="promoInformation">{{promoInformation}}</label>
							</form>
						</div>
					</transition>
					<!-- <div v-if="isPaymentAvailable">
						<div class="mb-2">{{ $t('Current payment method') }}</div>
						<h4 class="text-primary font-weight-normal">{{ $t('Credit Card') }} -
							{{ $t('Card number ending in') }} {{ lastCardNumber }}</h4>
						<div class="powered-by-stripe mt-5 mb-5 d-flex align-items-center">
							<img src="/img/stripe.png" alt="Powered by Stripe" class="mr-3">
							<span>{{ $t('Payments are securely processed each month with Stripe') }}</span>
						</div>
					</div>
					<div v-else>
						{{ $t('No available payment method, please add one now') }}
					</div>
					<form class="edit-profile-form mt-5" @submit.prevent="updatePayment">
						<div class="mb-2">
							<span v-if="!isPaymentAvailable">{{ $t('Add Credit Card') }}</span>
							<span v-else>{{ $t('Update Credit Card') }}</span>
						</div>
						<div class="form-group">
							<label class="mb-0">{{ $t('Cardholder Name') }}</label>
							<input type="text" class="form-control" v-model="cardHolderName"
								required>
						</div>
						<div class="form-group">
							<label class="mb-0">{{ $t('Credit Card Details') }}</label>
							<div class="form-control d-flex align-items-center credit-card-input">
								<i class="material-icons mr-1">credit_card</i>
								<input type="text" pattern="\d*" class="b-0 bg-transparent"
									:placeholder="$t('Card Number')" v-model="cardNumber" required>
								<input type="text" class="expired-date b-0 bg-transparent ml-auto"
									pattern="\d*" maxlength="2" :placeholder="$t('MM')"
									v-model="expiredDateMonth" required>
								<span class="expired-date-divider">/</span>
								<input type="text" class="expired-date b-0 bg-transparent"
									pattern="\d*" maxlength="2" :placeholder="$t('YY')"
									v-model="expiredDateYear" required>
								<input type="text" class="expired-date b-0 bg-transparent ml-2"
									pattern="\d*" maxlength="3" :placeholder="$t('CVC')"
									v-model="cvc" required>
							</div>
						</div>
						<div class="form-group mb-4">
							<label class="mb-0">{{ $t('Billing Address Line 1') }}</label>
						<input type="text" class="form-control" v-model="billingAddress"
								required>
						</div> -->
						<!-- Save Card -->
						<!-- <button type="submit" class="btn btn-primary"
							:class="{ 'is-loading': isSavingCard }">
							<span>{{ $t('Save Payment Settings') }}</span>
						</button>
					</form>  -->
				</div>

				<!-- General -->
				<div class="tab-content" v-if="tab === 'general'">
					<!-- <div class="plan-description mb-5 ml-3">
						<label class="custom-control custom-checkbox mb-3">
							<input type="checkbox" class="custom-control-input"
								v-model="isEnableAdvance" @change="updateSettingLayout">
							<h5 class="custom-control-label text-white pl-2">
								{{ $t('Enabled advanced layout on composition') }}</h5>
							<div class="sub-title pl-2">
								{{ $t('This will enable more preset for different screen resolutions') }}
							</div>
						</label>
					</div> -->
					<!-- dummy data -->
					<div class="plan-description mb-5 ml-3">
						<label class="custom-control custom-checkbox mb-3">
							<input type="checkbox" class="custom-control-input"
								v-model="isEnableDummy" @change="updateSettingLayout">
							<h5 class="custom-control-label text-white pl-2">
								{{ $t('Enabled dummy data on rundown asset') }}</h5>
							<div class="sub-title pl-2">
								{{ $t('automatically fill rundown asset data when created') }}</div>
						</label>
					</div>
					<!-- multiple item -->
					<div class="plan-description mb-5 ml-3">
						<label class="custom-control custom-checkbox mb-3">
							<input type="checkbox" class="custom-control-input"
								v-model="isEnableAllPreview" @change="updateSettingLayout">
							<h5 class="custom-control-label text-white pl-2">
								{{ $t('Enabled multiple asset on preview pane') }}</h5>
							<div class="sub-title pl-2">
								{{ $t('By default only one asset can be visible at a time') }}
							</div>
						</label>
					</div>
					<!-- idle logo grafias live -->
					<div class="plan-description mb-5 ml-3">
						<label class="custom-control custom-checkbox mb-3">
							<input type="checkbox" class="custom-control-input"
								v-model="isEnableShowLogo" @change="updateSettingLayout">
							<h5 class="custom-control-label text-white pl-2">
								{{ $t('Show logo when output is idle') }}</h5>
							<div class="sub-title pl-2">
								{{ $t('By default, it doesn\'t show when output is Live') }}
							</div>
						</label>
						<!-- <div class="plan-description mt-5 ml-4 pl-2">
							<label class="mb-3">
								<h5 class="text-white">
									{{ $t('Lighstream API KEY') }} <span class="text-small text-secondary ml-2" v-if="user.is_api_key_enabled">(Api Key has been enabled)</span> <span class="text-small text-secondary ml-2" v-if="!user.is_api_key_enabled">(You don't have api key yet)</span>
								</h5>
								<div class="sub-title">
									<div class="form-group" v-if="user.is_api_key_enabled">
										<input type="text" class="form-control" style="width: 365px;" v-model="apiKey" placeholder="***********************************">
									</div>
									<div class="form-group" v-if="!user.is_api_key_enabled">
										<input type="text" class="form-control" style="width: 365px;" v-model="apiKey">
									</div>
								</div>
								<div class="">
									<button :class="{'is-loading': isCheckingApi}" class="btn btn-submit btn-primary mb-3 capitalize" :disabled="!apiKey" @click="checkingApi">Update Key</button>
								</div>
							</label>
						</div> -->
						<h5 class="text-white pl-4 ml-2 mt-5">Clear Cache</h5>
						<div class="sub-title pl-4 ml-2">
							{{ $t('Remove all local storage and re-cached all new asset on your rundown') }}
						</div>
						<div class="pl-4">
							<button class="btn btn-submit btn-primary mt-3 pl-4 ml-2 capitalize" @click="isRemoveLocalForage = true">Delete All Cache</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Remove Picture -->
		<div class="modals">
			<modal size="small" @close="isRemovePictureVisible = false"
				v-if="isRemovePictureVisible">
				<template slot="header">
					<span class="mb-0">{{ $t('Profile Picture') }}</span>
				</template>
				<template slot="body">
					{{ $t('Remove your current picture profile') }}?
				</template>
				<template slot="footer">
					<button type="submit" class="btn btn-submit btn-primary"
						:class="{ 'is-loading': isRemovingPicture }" @click="removePicture">
						{{ $t('Yes, Remove') }}
					</button>
					<button type="submit" class="btn btn-default"
						@click="isRemovePictureVisible = false">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>

			<!-- Upgrade Role -->
			<modal size="small-medium" class="upgrade-modal" @close="isUpgradeVisible = false"
				v-if="isUpgradeVisible">
				<template slot="header">
					<h5 class="mb-0">{{ $t('Subscription Update') }}</h5>
				</template>
				<template slot="body">
					{{ $t('Update your subscription to PRO? you will be billed on the next billing cycle') }}?
				</template>
				<template slot="footer">
					<button type="submit" class="btn btn-submit btn-primary"
						:class="{ 'is-loading': isRemovingPicture }" @click="upgrade">
						{{ $t('Yes, Confirmed') }}
					</button>
					<button type="submit" class="btn btn-default" @click="isUpgradeVisible = false">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>
			<!-- cancel Subscription -->
			<modal
				class="cancel-warning"
				size="small"
				@close="isCancelVisible = false"
				v-if="isCancelVisible"
				>
				<template slot="header">
					<p class="material-icons-warning text-center">warning</p>
					<span class="ml-5">{{ $t('Cancel subscription') }}</span>
				</template>
				<template slot="body">
					<div class="text-base">{{ $t('Sorry to see you leave and you are welcome back! We set your subscription to free after your period has ended') }}.</div>
				</template>
				<template slot="footer">
					<button type="submit" class="btn btn-submit btn-primary"
						:class="{ 'is-loading': isLoadingCancel }" @click="cancelSubs">
						{{ $t('Yes') }}
					</button>
					<button type="submit" class="btn btn-default" @click="cancelForm">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>
			<!-- Payment Success -->
			<modal size="small-medium" class="swap-modal" @close="goToRundown" v-if="modalSuccessPayment">
				<template slot="header">
					<h5 class="mb-0">{{ $t('Payment Success') }}</h5>
				</template>
				<template slot="body">
					<div class="text-center mt-2 mb-3">
						<img src="/img/logo/grafias_medium_ondark.png" alt="xls" width="150px"/>
						<h5 class="mt-4 text-white">{{ $t(`Your subscription has been updated, your current subscription is ${packageName}`) }}</h5>
						<h5 class="text-white">{{ $t(' Thank you for your purchase') }}</h5>
					</div>
				</template>
				<template slot="footer">
					<button type="submit" class="btn btn-default" @click="goToRundown()">
						{{ $t('Go to rundown') }}
					</button>
					<button type="submit" class="btn btn-submit btn-primary"
						@click="isModalnvoiceVisible = true">
						{{ $t('Invoice') }}
					</button>
				</template>
			</modal>
		</div>

		<!-- Payment Loader -->
		<div class="full-loader" v-if="isSavingCard">
			<div class="message-box text-center">
				<div class="message-box-icon flex-center mb-4">
					<div class="white-dot"></div>
				</div>
				<h3 class="mb-4">{{ $t('Verifying Payment') }}</h3>
				<!-- <div class="text-lg mb-4">Please wait for a few seconds, we will redirect you to your dashboard</div> -->
			</div>
		</div>

		<!-- change password Form -->
		<change-password-profile-form
			@close="isFormPasswordVisible = false"
			v-if="isFormPasswordVisible"
		/>

		<!-- Invoice Modal -->
		<invoice-modal
			:data="dataTransactionSuccess"
			@close="isModalnvoiceVisible = false"
			v-if="isModalnvoiceVisible"
		/>

		<!-- more features modal -->
		<modal
			size="small"
			@close="isShowMoreFeature = false"
			v-if="isShowMoreFeature"
			>
			<template slot="header">
				<span class="ml-1">{{ $t('More Features') }}</span>
			</template>
			<template slot="body">
				<div class="text-base">{{ $t('Your account will be converted as') }} <span class="text-primary">{{ $t('Free account') }}</span>, {{ $t('with basic features of Grafias, you can upgrade for more features in your subscription page') }}.</div>
			</template>
			<template slot="footer">
				<button type="submit" class="btn btn-submit btn-primary mt-4"
					:class="{ 'is-loading': isLoadingMoreFeature }" @click="changeToClientRole">
					{{ $t('Proceed') }}
				</button>
				<button type="submit" class="btn btn-default mt-4" @click="isShowMoreFeature = false">
					{{ $t('Cancel') }}
				</button>
			</template>
		</modal>

		<!-- modal change payment method -->
		<modal size="medium" :hideFooter="true" class="swap-modal" @close="isChangePaymentModal = false" v-if="isChangePaymentModal">
			<template slot="header">
				<h5 class="mb-0">{{ $t('Change Credit Card') }}</h5>
			</template>
			<template slot="body">
				<div class="col-sm-12 payment-form">
					<div>
						<form @submit.prevent="">
							<div>
								<h2 class="font-weight-normal">{{ $t('Payment') }}</h2>
							</div>
							<span>Subscription & payment are handled by </span><span><a href="https://stripe.com" target="_blank">Stripe</a></span>
							<div  class="form-group mt-3">
								<div class="mh-50">
									<input v-model="paymentName" type class="form-control field" placeholder="Name" :class="{'error-input': paymentName === '', 'mb-4': paymentName.length >= 5 || paymentName.length === 0}">
									<span v-if="paymentName.length < 5 && paymentName.length !== 0" class="error-color-input">Please enter a name of at least 5 characters</span>
								</div>
								<input v-model="paymentEmail" type="email" name="email" class="form-control field  mb-3" placeholder="E-mail" :class="{'error-input': paymentEmail === ''}">
								<div id="card-element" class="stripe-field"></div>
								<!-- We'll put the error messages in this element -->
								<div id="card-errors" role="alert"></div>
							</div>
							<div class="d-flex justify-content-between">
								<div>
									<button :class="{ 'is-loading': isPaymentSuccess }"
									class="btn btn-primary mb-2 mr-2" :disabled="!isValidNameAndEmail && isValidCreditCard" @click="createPaymentForChangeCC">Change Credit Card</button>
								</div>
								<div>
									<button class="btn btn-default mb-2" @click="isChangePaymentModal = false">Cancel</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</template>
			<template slot="footer">
			</template>
		</modal>
		<!-- Remove Picture -->
		<div class="modals">
			<modal size="small" @close="isRemoveLocalForage = false"
				v-if="isRemoveLocalForage">
				<template slot="header">
					<span class="mb-0">{{ $t('Confirm Clear Cache') }}</span>
				</template>
				<template slot="body">
					{{ $t('Remove all local storage on this browser') }}?
				</template>
				<template slot="footer">
					<button type="submit" class="btn btn-submit btn-primary"
						:class="{ 'is-loading': isRemovingPicture }" @click="clearLocaforage">
						{{ $t('Yes, Proceed') }}
					</button>
					<button type="submit" class="btn btn-default"
						@click="isRemoveLocalForage = false">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localforage from 'localforage';
import { mapGetters, mapActions } from 'vuex';
import ChangePasswordProfileForm from '@/components/ChangePasswordProfileForm.vue';
import InvoiceModal from '@/components/InvoiceModal.vue';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage, duplicateVar, isValidEmail } from '@/lib/helper';
import fileApi from '@/api/file';
import authApi from '@/api/auth';
import packagesApi from '@/api/packages';
import transactionApi from '@/api/transactions';
import userSubscriptionApi from '@/api/userSubscriptions';
import promoCodeApi from '@/api/promoCode';
import lightstreamsApi from '@/api/lightstream';
import userApi from '@/api/user';
import subscriptionApi from '@/api/subscription';
import {
	featureNamesDefault,
} from '@/lib/statics';

const publicKeyStripe = process.env.VUE_APP_PK_STRIPE ? process.env.VUE_APP_PK_STRIPE : 'pk_test_cEeFbGOnhljGBjRCCjp7h3dL00SPobqhFE';
export default {
	name: 'dashboard',
	components: {
		Modal,
		ChangePasswordProfileForm,
		InvoiceModal,
	},
	data() {
		return {
			tab: 'profile',
			defaultPictureProfile: './img/icons/android-icon-144x144.png',
			picture: '',
			pictureFile: null,
			isRemovePictureVisible: false,
			isUploadingPicture: false,
			isRemovingPicture: false,
			isEdit: false,
			isSaving: false,
			name: '',
			email: '',
			phone: '',
			timezone: 7,
			language: 'en',
			// Timezones
			timezones: [
				{ key: 'Europe/Oslo', label: 'Europe/Oslo' },
				{ key: 'America/Los_Angeles', label: 'America/Los Angeles' },
				{ key: 'Europe/London', label: 'Europe/London' },
				{ key: 'America/New_York', label: 'America/New York' },
				{ key: 'Asia/Tokyo', label: 'Asia/Tokyo' },
			],
			languages: [
				{ key: 'en', label: 'English' },
				{ key: 'no', label: 'Norwegian' },
			],
			descriptionPackage: [
				{ key: 'Display-Output', label: 'Display Output' },
				{ key: 'Assets-In-Rundown', label: 'Assets In Rundown' },
				{ key: 'Rundowns', label: 'Rundowns' },
				{ key: 'Adding-Users', label: 'Adding Users (Collaborate)' },
				{ key: 'Storage', label: 'Storage' },
				{ key: 'Time-Constraint', label: 'Time Constraint' },
				{ key: 'Support', label: 'Support' },
				{ key: 'Price-per-month', label: 'Price per month' },

			],
			isCancelVisible: false,
			isUpgradeVisible: false,
			// isPaymentAvailable: true,
			isNoPaymentVisible: false,
			cardHolderName: '',
			cardNumber: '',
			expiredDateMonth: '',
			expiredDateYear: '',
			cvc: '',
			billingAddress: '',
			isSavingCard: false,
			isEnableAdvance: false,
			isEnableDummy: true,
			colorBackground: '#23FF00',
			settings: '',
			isSavingSettings: false,
			isshowColorPickerHeader: false,
			isLoadingCancel: false,
			packages: [],
			isEnableAllPreview: false,
			isEnableShowLogo: false,
			isShowTour: false,
			lastKeywordTemplate: '',
			lastCategoryTemplate: false,
			modalSuccessPayment: false,
			lastCategoryGallery: '',
			lastKeywordGallery: '',
			isModalnvoiceVisible: false,
			dataTransactionSuccess: {},
			items: [],
			totalItems: 0,
			lastPage: 0,
			isFetching: false,
			keyword: '',
			// stripeAPIToken: 'pk_live_qOGef0VGeBRe9HXyldBgAMRp00BAq13NDG',
			stripeAPIToken: publicKeyStripe,
			stripe: '',
			elements: '',
			card: null,
			stripeOptions: {
				// see https://stripe.com/docs/stripe.js#element-options for details
			},
			customer: {},
			promoCode: '',
			isShowPayment: false,
			currentItem: {},
			selectedPackage: null,
			paymentName: '',
			paymentEmail: '',
			isPaymentSuccess: false,
			isCheckPromoCode: false,
			promoInformation: '',
			promoValid: false,
			// change password
			isChangePassword: false,
			isFormPasswordVisible: false,
			cancelledSubs: null,
			isValidCreditCard: true,
			isCancelSubs: false,
			// more feature
			isShowMoreFeature: false,
			isLoadingMoreFeature: false,
			packagePrice: '',
			transactionPrice: null,
			currentCoupon: null,
			packageName: '',
			// change payment
			isChangePaymentModal: false,
			isSavingPayment: false,
			// apply promo from email
			promoCodeFromEmail: '',
			isApplyingCoupon: false,
			isRemoveLocalForage: false,
			// lightstream
			apiKey: '',
			isCheckingApi: false,
			// default package
			featureNamesDefault,
			// filtersubscription
			activeToggleSubs: '',
			filteredPackage: [],

			// new subs
			nameSubs: '',
			emailSubs: '',
			assist: 'Support',
			assistOther: 'Other',
			notes: '',
			isSendingSubs: false,
		};
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
			setRole: 'setRole',
		}),
		requestSubs() {
			this.isSendingSubs = true;
			const callback = (response) => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: this.assist,
					text: response.message,
				});

				// set default value subs
				if (!this.nameSubs) this.nameSubs = this.name;
				if (!this.emailSubs) this.emailSubs = this.email;
				this.notes = '';
				this.assist = 'Support';
				this.assistOther = 'Other';
				this.isSendingSubs = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.assist,
					text: message,
				});
				this.isSendingSubs = false;
			};
			const params = {
				name: this.nameSubs,
				email: this.emailSubs,
				notes: this.notes,
				services: this.assist,
			};
			if (this.assist === 'Other') {
				params.services = this.assistOther;
			}
			subscriptionApi.request(params, callback, errorCallback);
		},
		goToRundown() {
			this.$router.push('/').catch(() => {});
		},
		convertDataSize(size) {
			if (size === 'UNLIMITED') return 'UNLIMITED';
			if (size < 1000) {
				return `${size}MB`;
			}
			return `${size / 1000}GB`;
		},
		cancelForm() {
			this.cancelledSubs = null;
			this.isCancelVisible = null;
		},
		checkPromoCode() {
			this.isCheckPromoCode = true;
			const callback = (response) => {
				const promo = response.data;
				this.currentCoupon = promo.coupon;
				const activePackage = response.data.packages;
				const messageDiscountPrice = promo.coupon.amount_off ? promo.coupon.amount_off : '';
				const messageDiscountPercentage = promo.coupon.percent_off ? promo.coupon.percent_off : '';
				let totalDiscount = '';
				if (messageDiscountPrice) {
					totalDiscount = `: $${messageDiscountPrice / 100}`;
				} else if (messageDiscountPercentage) {
					totalDiscount = `: ${messageDiscountPercentage}%`;
				}
				// eslint-disable-next-line eqeqeq
				const isAllPackage = activePackage.length == 0;
				if (!isAllPackage) {
					const currentPackageId = this.selectedPackage && this.selectedPackage.id ? this.selectedPackage.id : null;
					if (currentPackageId) {
						const validPackage = activePackage.findIndex(({ id }) => id === currentPackageId);
						if (validPackage === -1) {
							// this.$notify({
							// 	group: 'app',
							// 	type: 'error',
							// 	title: 'Error, You cannot use promo code for this package',
							// 	text: 'You cannot use this promo code for this current package',
							// });
							this.promoInformation = 'You cannot use this promo code for this current package';
							this.promoValid = false;
							this.isCheckPromoCode = false;
						} else {
							// this.$notify({
							// 	group: 'app',
							// 	type: 'success',
							// 	title: 'success, promo code Available',
							// 	text: `your promo code is activated${totalDiscount} OFF`,
							// });
							this.promoInformation = `Your promo code is activated${totalDiscount} OFF`;
							this.promoValid = promo.code;
							this.isCheckPromoCode = false;
						}
					} else {
						// this.$notify({
						// 	group: 'app',
						// 	type: 'error',
						// 	title: 'Error, You have not select any package',
						// 	text: 'You have not select any package',
						// });
						this.promoInformation = 'You have not select any package';
						this.promoValid = false;
						this.isCheckPromoCode = false;
					}
				} else {
					// this.$notify({
					// 	group: 'app',
					// 	type: 'success',
					// 	title: 'success, promo code Available',
					// 	text: `your promo code is activated${totalDiscount} OFF`,
					// });
					this.promoInformation = `Your promo code is activated${totalDiscount} OFF`;
					this.promoValid = promo.code;
					this.isCheckPromoCode = false;
				}
			};
			const errCallback = () => {
				// this.$notify({
				// 	group: 'app',
				// 	type: 'error',
				// 	title: 'Failed, promo code is unavailable',
				// 	text: message,
				// });
				this.promoInformation = 'Promo code is unavailable';
				this.promoValid = false;
				this.isCheckPromoCode = false;
			};
			promoCodeApi.getByCode(this.promoCode, callback, errCallback);
		},
		showCancel(subscription) {
			this.cancelledSubs = duplicateVar(subscription);
			this.isCancelVisible = true;
			this.isCancelSubs = false;
		},
		cancelSubs() {
			this.isLoadingCancel = true;
			const param = {
				package_id: this.cancelledSubs && this.cancelledSubs.package_id ? this.cancelledSubs.package_id : null,
				user_id: this.userId,
			};

			const callback = (response) => {
				const user = response.data.user;

				if (this.userSubscriptions && this.userSubscriptions.length > 1) {
					for (let index = 0; index < this.userSubscriptions.length; index++) {
						const subscription = this.userSubscriptions[index];
						if (subscription.id !== this.cancelledSubs.id) {
							this.switchSubscription(subscription.package_id);
						}
					}
				}
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'success remove subscription',
					text: 'Your subscription has been updated, your current subscription is Free',
				});
				this.setUser(user);
				this.cancelledSubs = null;
				this.isCancelVisible = false;
			};

			const errCallback = (e) => {
				this.isLoadingCancel = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, something went wrong when cancel subscription',
					text: message,
				});
				this.cancelledSubs = null;
			};
			userSubscriptionApi.cancel(param, callback, errCallback);
		},
		checkout(pkg) {
			this.packagePrice = this.commaFormatted(pkg.price);
			if (this.promoValid && this.currentCoupon) {
				if (this.currentCoupon.amount_off) this.packagePrice = this.commaFormatted(parseInt(pkg.price) - (parseInt(this.currentCoupon.amount_off) / 100));// initially amount of is 10.00 so would be 1000 in json int
				if (this.currentCoupon.percent_off) this.packagePrice = this.commaFormatted(parseInt(pkg.price) - (parseInt(pkg.price) * (parseInt(this.currentCoupon.percent_off) / 100))); // no need to parse comma
				if (this.packagePrice <= 0) this.packagePrice = 0;
			}
			this.packageName = pkg.name;
			this.isPaymentSuccess = true;
			const param = {
				package_id: pkg.id,
				bill_to_name: this.paymentName,
				bill_to_email: this.paymentEmail,
			};
			if (this.promoValid) {
				param.promo_code = this.promoCode.toUpperCase();
			}
			const callback = (response) => {
				if (response && response.error) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed, Payment Declined',
						text: 'Failed, Payment Declined',
					});
				}
				this.customer = response.data;
				const card = this.card;
				this.createPaymentMethod({ card });
				// this.isPaymentSuccess = false;
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, Payment Declined',
					text: message,
				});
				this.isPaymentSuccess = false;
			};
			transactionApi.checkout(param, callback, errCallback);
		},
		handlePaymentThatRequiresCustomerAction(subscription, priceId, paymentMethodId) {
			if (subscription && subscription.status === 'active') {
				// subscription is active, no customer actions required.
				const callback = (response) => {
					const subsData = response.data;
					const transaction = subsData.transaction;
					this.transactionPrice = transaction.amount;
					const subsUser = subsData.user;
					this.dataTransactionSuccess = response.data.transaction;
					this.isPaymentSuccess = false;
					this.setUser(subsUser);
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'success, Payment Accepted',
						text: `Your subscription has been updated, your current subscription is ${this.packageName}`,
					});
					// this.$router.push('/').catch(() => {});
					this.getProfileUser();
					this.modalSuccessPayment = true;
				};
				const errCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed, Payment Declined',
						text: message,
					});
					this.isPaymentSuccess = false;
				};
				const invoiceId = subscription && typeof (subscription.latest_invoice) === 'string' ? subscription.latest_invoice : subscription.latest_invoice.id;
				const params = {
					subscription_id: subscription.id,
					invoice_id: invoiceId,
				};
				transactionApi.successed(params, callback, errCallback);
				return { subscription, priceId, paymentMethodId };
			}

			// If it's a first payment attempt, the payment intent is on the subscription latest invoice.
			// If it's a retry, the payment intent will be on the invoice itself.
			const latestInvoice = subscription && subscription.latest_invoice ? subscription.latest_invoice : null;
			const paymentIntent = latestInvoice && latestInvoice.payment_intent ? latestInvoice.payment_intent : null;
			if (
				paymentIntent.status === 'requires_action'
				|| (paymentIntent.status === 'requires_payment_method')
			) {
				return this.stripe
					.confirmCardPayment(paymentIntent.client_secret, {
						payment_method: paymentMethodId,
					})
					// eslint-disable-next-line consistent-return
					.then((result) => {
						if (result.error) {
							// start code flow to handle updating the payment details
							// Display error message in your UI.
							// The card was declined (i.e. insufficient funds, card has expired, etc)
							// throw result;\
							const message = result.error.message;
							this.$notify({
								group: 'app',
								type: 'error',
								title: 'Failed, Payment Declined',
								text: message,
							});
							this.isPaymentSuccess = false;
						} else if (result.paymentIntent.status === 'succeeded') {
							// There's a risk of the customer closing the window before callback
							// execution. To handle this case, set up a webhook endpoint and
							// listen to invoice.paid. This webhook endpoint returns an Invoice.
							const callback = (response) => {
								const subsData = response.data;
								const transaction = subsData.transaction;
								this.transactionPrice = transaction.amount;
								const subsUser = subsData.user;
								this.dataTransactionSuccess = response.data.transaction;
								this.setUser(subsUser);
								this.isPaymentSuccess = false;
								this.$notify({
									group: 'app',
									type: 'success',
									title: 'success, Payment Accepted',
									text: `Your subscription has been updated, your current subscription is $${this.packageName}`,
								});
								// this.$router.push('/').catch(() => {});
								this.getProfileUser();
								this.modalSuccessPayment = true;
							};
							const errCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Failed, Payment Declined',
									text: message,
								});
								this.isPaymentSuccess = false;
							};
							const params = {
								subscription_id: subscription.id,
								invoice_id: latestInvoice.id,
							};
							transactionApi.successed(params, callback, errCallback);
						}
					});
			}
			// No customer action needed
			return { subscription, priceId, paymentMethodId };
		},
		// eslint-disable-next-line no-unused-vars
		createPaymentMethod({ card, isPaymentRetry, invoiceId }) {
			// eslint-disable-next-line no-undef
			this.stripe
				.createPaymentMethod({
					type: 'card',
					card,
					billing_details: {
						name: this.paymentName,
						email: this.paymentEmail,
					},
				})
				.then((result) => {
					// const transactionId = result.transaction_id;
					if (result.error) {
						this.isPaymentSuccess = false;
						const error = result.error;
						const message = error.message;
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Failed, Payment Declined',
							text: message,
						});
					}
					return result;
				}).then((result) => {
					const paymentMethod = result && result.paymentMethod ? result.paymentMethod.id : '';
					if (paymentMethod) {
						this.createSubscription(paymentMethod);
					}
				});
		},
		createSubscription(paymentMethodId) {
			this.isPaymentSuccess = true;
			const trxId = this.customer.transaction.id;
			const params = {
				status: 'paid',
				transaction_id: trxId,
				payment_method_id: paymentMethodId,

			};
			const callback = (response) => {
				const subscription = response.data.subscription;
				const priceId = response.price_id;
				this.handlePaymentThatRequiresCustomerAction(subscription, priceId, paymentMethodId);
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, Payment Declined',
					text: message,
				});
				this.isPaymentSuccess = false;
			};
			transactionApi.process(params, callback, errCallback);
		},
		configureStripe() {
			// eslint-disable-next-line no-undef
			this.stripe = Stripe(this.stripeAPIToken, { locale: 'en' });
			this.elements = this.stripe.elements();
			this.card = this.elements.create('card', {
				style: {
					base: {
						iconColor: '#6051ff',
						color: 'white',
						lineHeight: '48px',
						fontWeight: 400,
						fontFamily: '"Open Sans", "Helvetica Neue", "Helvetica", sans-serif',
						fontSize: '15px',
						'::placeholder': {
							color: '#CFD7DF',
						},
					},
				},
			});
			this.card.mount('#card-element');

			this.card.on('change', (event) => {
				const displayError = document.getElementById('card-errors');
				if (event.error) {
					displayError.textContent = event.error.message;
					this.isValidCreditCard = false;
				} else if (event.empty) {
					displayError.textContent = '';
					this.isValidCreditCard = false;
				} else {
					displayError.textContent = '';
					this.isValidCreditCard = true;
				}
			});
		},
		showPayment(item) {
			this.paymentName = this.user && this.user.name ? this.user.name : '';
			this.paymentEmail = this.user && this.user.email ? this.user.email : '';
			this.selectedPackage = item;
			this.tab = 'payment';
			this.$nextTick(() => {
				this.configureStripe();
			});
		},
		switchSubscription(packageId) {
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				this.isLoadingCancel = false;
				this.isCancelVisible = false;
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Error when activate subscription',
					text: message,
				});
				this.isLoadingCancel = false;
				this.isCancelVisible = false;
			};
			const params = {
				package_id: packageId,
			};
			userSubscriptionApi.activate(params, callback, errCallback);
		},
		showDetails() {
			this.tab = 'subs_details';
		},
		setTab() {
			this.tab = 'general';
			this.$router.push('/settings?menu=general').catch(() => {});
		},
		itemPackageFeatures(item) {
			if (item && item.packageFeatures) {
				return item.item.packageFeatures;
			}
			return [];
		},
		printCurrentSubs() {
			let packageName = 'Free';
			const subscriptions = this.userSubscriptions;
			if (subscriptions) {
				// eslint-disable-next-line camelcase
				const activeSubs = subscriptions.find(({ is_current_active }) => is_current_active);
				packageName = activeSubs && activeSubs.package_name ? activeSubs.package_name : 'Free';
			}
			return packageName;
		},
		sortFeature(features) {
			const customSorting = [3, 1, 2, 4, 5, 7, 9, 10, 12, 8, 11]; // My own sorting order
			// eslint-disable-next-line
			features.sort((a, b) => {
				return customSorting.indexOf(a.feature_id) - customSorting.indexOf(b.feature_id);
			});
			return features;
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = {
				is_published: 1,
			};
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.items = items;
				for (let index = 0; index < this.items.length; index++) {
					const element = this.items[index];
					for (let index = 0; index < featureNamesDefault.length; index++) {
						const packageFeature = featureNamesDefault[index];
						if (!element.packageFeatures.find(obj => obj.feature_id === packageFeature.feature_id)) {
							if (element.type !== 'non_feature') element.packageFeatures.push(packageFeature);
						}
					}
					// eslint-disable-next-line camelcase
					const indexId6 = element.packageFeatures.findIndex(({ feature_id }) => feature_id === 6);
					if (indexId6 !== -1) {
						element.packageFeatures.splice(indexId6, 1);
					}
					// sort by id
					this.sortFeature(element.packageFeatures);
				}
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
				const menu = this.$route.query && this.$route.query.menu ? this.$route.query.menu : null;
				if (menu === 'subscribe') {
					this.tab = 'subscription';
				} else if (menu === 'payment') {
					this.tab = 'payment';
					const packageId = this.$route.query && this.$route.query.packageId ? this.$route.query.packageId : null;
					const index = this.items.findIndex(({ id }) => id === parseInt(packageId));
					if (index !== -1) {
						this.selectedPackage = this.items[index];
						this.$nextTick(() => {
							this.configureStripe();
						});
					} else {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Packages',
							text: 'Package not found',
						});
						this.tab = 'subscription';
						this.$router.push('/settings').catch(() => {});
					}
				}

				// init active toggle when there is active package
				if (this.ActiveSubscription && this.ActiveSubscription.package_id) {
					const currentSubs = items.filter(item => (item.id === this.ActiveSubscription.package_id));
					if (currentSubs && currentSubs[0]) {
						if ((currentSubs[0].type === 'subscription' && !currentSubs[0].uid)
							&& ((currentSubs[0].length === 30 && currentSubs[0].length_type === 'day')
							|| (currentSubs[0].length === 1 && currentSubs[0].length_type === 'month'))) {
							this.filterSubscription('m');
						}
						if ((currentSubs[0].type === 'subscription' && !currentSubs[0].uid)
							&& ((currentSubs[0].length === 365 && currentSubs[0].length_type === 'day')
							|| (currentSubs[0].length === 12 && currentSubs[0].length_type === 'month'))) {
							this.filterSubscription('y');
						}
						if (currentSubs[0].type === 'non_feature' || currentSubs[0].uid) {
							this.filterSubscription('c');
						}
					}
				} else {
					this.filterSubscription('m');
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Packages',
					text: message,
				});
				this.isFetching = false;
			};
			packagesApi.getList(params, callback, errorCallback);
		},
		onSelectPicture(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					this.isUploadingPicture = true;
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload File',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}
					const params = new FormData();
					params.append('file', file);
					const callback = (response) => {
						const picture = response.data;
						this.picture = picture;
						this.updatePicture();
						this.isUploadingPicture = false;
					};
					const errorCallback = () => {
						this.isUploadingPicture = false;
					};
					fileApi.upload(params, callback, errorCallback);

					this.pictureFile = file;
					// Read image for preview
					const reader = new FileReader();
					reader.onload = (e) => {
						this.picture = e.target.result;
					};
					reader.readAsDataURL(file);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		confirmRemovePicture() {
			this.isRemovePictureVisible = true;
		},
		removePicture() {
			this.picture = null;
			this.updatePicture();
			this.isRemovePictureVisible = false;
		},
		updatePicture() {
			const params = {
				picture: this.picture,
			};
			const callback = (response) => {
				const message = response.message;
				const data = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Picture',
					text: message,
				});
				this.setUser(data);
				this.apiKey = '';
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Picture',
					text: message,
				});
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		edit() {
			this.isEdit = true;
		},
		updateProfile() {
			const name = this.name && this.name.lenght > 1 ? this.name.trim() : this.name;
			const email = this.email && this.email.lenght > 1 ? this.email.trim() : this.email;
			const phone = this.phone && this.phone.lenght > 1 ? this.phone.trim() : this.phone;
			const params = {
				name,
				email,
				phone,
				timezone: this.timezone,
				language: this.language,
			};
			if (this.apiKey) params.lightstream_api_key = this.apiKey;
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: this.$t('Update Profile'),
					text: message,
				});
				this.isEdit = false;
				this.apiKey = '';
				this.isCheckingApi = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Update Profile'),
					text: message,
				});
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		setProfileData() {
			this.name = duplicateVar(this.user.name);
			this.email = duplicateVar(this.user.email);
			this.phone = duplicateVar(this.user.phone);
			this.language = duplicateVar(this.user.language);
			if (this.user.timezone) {
				this.timezone = duplicateVar(this.user.timezone);
			}
		},
		setSettingsData() {
			// @TODO: catch variable user setting if setting is undefined
			const settings = JSON.parse(this.user.settings);
			if (settings) {
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
				this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
				this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
				this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
				this.isShowTour = settings && settings.is_tour_visible ? duplicateVar(settings.is_tour_visible) : false;
				this.lastCategoryTemplate = settings && settings.last_category_template ? duplicateVar(settings.last_category_template) : 0;
				this.lastKeywordTemplate = settings && settings.last_keyword_template ? duplicateVar(settings.last_keyword_template) : '';
				this.lastCategoryGallery = settings && settings.last_category_gallery ? duplicateVar(settings.last_category_gallery) : 0;
				this.lastKeywordGallery = settings && settings.last_keyword_gallery ? duplicateVar(settings.last_keyword_gallery) : '';
				if (this.lastCategoryTemplate !== 0) {
					this.category = this.lastCategoryTemplate;
					this.categoryId = this.lastCategoryTemplate;
				} else {
					this.category = 'all';
				}
				if (this.lastKeywordTemplate) {
					this.keyword = this.lastKeywordTemplate;
				} else {
					this.keyword = '';
				}
				// this.colorBackground = duplicateVar(settings.background_color);
			} else {
			// @TODO: catch variable user setting if setting is undefined
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = 0;
				this.isEnableDummy = 0;
				this.isEnableAllPreview = 0;
				this.isEnableShowLogo = 0;
				this.isShowTour = false;
				this.lastCategoryTemplate = 1;
				this.lastKeywordTemplate = '';
				this.lastCategoryGallery = 1;
				this.lastKeywordGallery = '';
				// this.colorBackground = '#FFFFFF';
			}
		},
		updateSettingLayout() {
			this.isSavingSettings = true;
			this.settings.is_enable_advance_layout = this.isEnableAdvance;
			this.settings.is_enable_dummy_item_data = this.isEnableDummy;
			this.settings.is_enable_all_preview = this.isEnableAllPreview;
			this.settings.is_enable_show_logo = this.isEnableShowLogo;
			this.settings.is_tour_visible = this.isShowTour;
			this.settings.last_category_template = this.lastCategoryTemplate;
			this.settings.last_keyword_template = this.lastKeywordTemplate;
			this.settings.last_category_gallery = this.lastCategoryGallery;
			this.settings.last_keyword_gallery = this.lastKeywordGallery;
			// this.settings.background_color = this.colorBackground;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const layout = paramsSettings;
			const params = layout;
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Settings',
					text: 'Settings has been updated',
				});
				this.isshowColorPickerHeader = false;
				this.isSavingSettings = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Settings',
					text: message,
				});
				this.isSavingSettings = false;
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		setPaymentData() {
			if (this.user.payment) {
				const paymentString = this.user.payment;
				const payment = JSON.parse(paymentString);
				this.cardHolderName = payment.card_holder_name;
				this.cardNumber = payment.card_number;
				this.expiredDateMonth = payment.expired_date_month;
				this.expiredDateYear = payment.expired_date_year;
				this.cvc = payment.cvc;
				this.billingAddress = payment.address;
			}
		},
		confirmUpgrade() {
			if (this.isPaymentAvailable) {
				this.isUpgradeVisible = true;
			} else {
				this.isNoPaymentVisible = true;
			}
		},
		upgrade() {
		},
		updatePayment() {
			this.isSavingCard = true;
			const payment = JSON.stringify(this.paymentCardParams);
			const params = { payment };
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Payment',
					text: message,
				});
				this.isSavingCard = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Payment',
					text: message,
				});
				this.isSavingCard = false;
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		// make it a humanly readable date
		getPeriod(item) {
			const length = item.length;
			const type = item.length_type;
			const resultDate = dayjs().to(dayjs().add(length, type));
			const parsedDate = this.replaceDate(resultDate, item);
			return parsedDate;
		},
		replaceDate(str) {
			let finalResultDate = str;
			const newStr = str.replace('in a ', '');
			const ina = newStr.replace('in ', '');
			finalResultDate = ina;
			if (finalResultDate.includes('days')) {
				finalResultDate = `for ${finalResultDate}`;
			} else if (finalResultDate.includes('months')) {
				finalResultDate = `for ${finalResultDate}`;
			} else {
				finalResultDate = `${finalResultDate}`;
			}
			return finalResultDate;
		},
		changeToClientRole() {
			this.isLoadingMoreFeature = true;
			// eslint-disable-next-line
			const rolesArray = ["client", "collaborator"];
			const params = {
				roles: JSON.stringify(rolesArray),
			};
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				this.setRole('client');
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: this.$t('Update features'),
					text: message,
				});
				this.isShowMoreFeature = false;
				this.isLoadingMoreFeature = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Update features'),
					text: message,
				});
				this.isLoadingMoreFeature = true;
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		commaFormatted(value) {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},
		backToSetting() {
			this.tab = 'profile';
			this.$router.push('/settings').catch(() => {});
		},
		backToSubs() {
			this.tab = 'subscription';

			// set default value subs
			if (!this.nameSubs) this.nameSubs = this.name;
			if (!this.emailSubs) this.emailSubs = this.email;
			this.notes = '';
			this.assist = 'Support';
			this.assistOther = 'Other';

			this.$router.push('/settings?menu=subscription').catch(() => {});
		},
		changePaymentModal() {
			this.paymentName = this.user && this.user.name ? this.user.name : '';
			this.paymentEmail = this.user && this.user.email ? this.user.email : '';
			this.isChangePaymentModal = true;
			this.$nextTick(() => {
				this.configureStripe();
			});
		},
		// cahnge payment method
		// eslint-disable-next-line no-unused-vars
		createPaymentForChangeCC({ card, isPaymentRetry }) {
			// eslint-disable-next-line no-undef
			this.stripe
				.createPaymentMethod({
					type: 'card',
					card: this.card,
					billing_details: {
						name: this.paymentName,
						email: this.paymentEmail,
					},
				})
				.then((result) => {
					// const transactionId = result.transaction_id;
					if (result.error) {
						this.isPaymentSuccess = false;
						const error = result.error;
						const message = error.message;
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Failed, Payment Declined',
							text: message,
						});
					}
					return result;
				}).then((result) => {
					const paymentMethod = result && result.paymentMethod ? result.paymentMethod : '';
					if (paymentMethod) {
						this.changePaymentMethod(paymentMethod);
					}
				});
		},
		changePaymentMethod(paymentMethod) {
			const customerId = this.user && this.user.customer_id ? this.user.customer_id : '';
			const paymentId = paymentMethod && paymentMethod.id ? paymentMethod.id : '';
			const params = {
				customer_id: customerId,
				payment_method_id: paymentId,
			};
			this.isSavingPayment = true;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Transactions',
					text: message,
				});
			};
			this.paymentName = '';
			this.paymentEmail = '';
			this.isSavingPayment = false;
			this.isChangePaymentModal = false;
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isSavingPayment = false;
			};
			userApi.changePaymentMethod(params, callback, errorCallback);
		},
		getProfileUser() {
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Profile',
					text: message,
				});
			};
			authApi.getProfile(callback, errorCallback);
		},
		applyCouponFromEmail() {
			this.isApplyingCoupon = true;
			const params = {
				code: this.promoCodeFromEmail,
			};
			const callback = () => {
				this.getProfileUser();
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Claim Coupon',
					text: 'Your coupon was used successfully',
				});
				this.promoCodeFromEmail = '';
				this.isApplyingCoupon = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Claim Coupon',
					text: message,
				});
				this.promoCodeFromEmail = '';
				this.isApplyingCoupon = false;
			};
			promoCodeApi.claimCoupon(params, callback, errorCallback);
		},
		clearLocaforage() {
			localforage.clear().then(() => {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Profile',
					text: 'Localforage has been cleared',
				});
				// eslint-disable-next-line
				location.reload();
				this.isRemoveLocalForage = false;
			}).catch(() => {
				// err message here
			});
		},
		promoUppercase(str) {
			return str.toUpperCase();
		},
		checkingApi() {
			this.isCheckingApi = true;
			const params = {
				lightstream_api_key: this.apiKey,
			};
			const callback = () => {
				this.updateProfile();
			};
			const errorCallback = () => {
				const message = 'Invalid api key';
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Api Key',
					text: message,
				});
				this.apiKey = '';
				this.isCheckingApi = false;
			};
			lightstreamsApi.checkingApi(params, callback, errorCallback);
		},
		filterSubscription(value) {
			this.activeToggleSubs = value;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isFinance: 'isFinance',
		}),
		filteredSelfSubs() {
			const filter = item => (item.id === this.ActiveSubscriptionId);
			return this.items.filter(filter);
		},
		userId() {
			return this.user && this.user.id ? this.user.id : null;
		},
		featureNames() {
			const featureNames = [
				{ feature_name: 'Rundown' },
				{ feature_name: 'Outputs' },
				{ feature_name: 'Total Assets' },
				{ feature_name: 'Collaborators' },
				{ feature_name: 'Storage' },
				{ feature_name: 'API Call' },
				{ feature_name: 'Upload Templates' },
				{ feature_name: 'Grafias Bridge' },
				{ feature_name: 'Multiple Logons' },
				{ feature_name: 'Render .png' },
				{ feature_name: 'Custom Templates' },
			];
			return featureNames;
		},
		userSubscriptions() {
			const userSubs = this.user && this.user.userSubscriptions ? this.user.userSubscriptions : '';
			return userSubs;
		},
		ActiveSubscriptionId() {
			return this.ActiveSubscription && this.ActiveSubscription.package_id ? this.ActiveSubscription.package_id : null;
		},
		ActiveSubscription() {
			const subscriptions = this.userSubscriptions;
			if (subscriptions) {
				// eslint-disable-next-line camelcase
				const activeSubs = subscriptions.find(({ is_current_active }) => is_current_active);
				return activeSubs;
			}
			return null;
		},
		userSettings() {
			return this.user && this.user.settings ? this.user.settings : null;
		},
		timezoneLabel() {
			const timezone = this.timezones.find(({ key }) => key === this.timezone);
			return timezone ? timezone.label : '-';
		},
		languageLabel() {
			const language = this.languages.find(({ key }) => key === this.language);
			return language ? language.label : '-';
		},
		isPaymentAvailable() {
			return this.user && this.user.payment && this.user.payment !== '';
		},
		paymentCardParams() {
			const cardHolderName = this.cardHolderName.trim();
			const cardNumber = this.cardNumber.trim();
			const address = this.billingAddress.trim();
			const params = {
				card_holder_name: cardHolderName,
				card_number: cardNumber,
				expired_date_month: this.expiredDateMonth,
				expired_date_year: this.expiredDateYear,
				cvc: this.cvc,
				address,
			};
			return params;
		},
		lastCardNumber() {
			const cardNumber = this.cardNumber;
			return cardNumber.substring(cardNumber.length - 4);
		},
		swatchStyleBackgrounColor() {
			const { menu } = this;
			return {
				backgroundColor: this.colorBackground,
				cursor: 'pointer',
				height: '15px',
				width: '15px',
				borderRadius: menu ? '50%' : '50px',
				transition: 'border-radius 200ms ease-in-out',
			};
		},
		isValidNameAndEmail() {
			return this.paymentEmail !== '' && this.paymentName !== '' && this.paymentName.length >= 5;
		},
		isValidEmailAddress() {
			return isValidEmail(this.email);
		},
		isValidSubsEmailAddress() {
			return isValidEmail(this.emailSubs);
		},
		printLeftDaysSubs() {
			const diffInDays = '';
			let endDays = new Date();
			let startDays = new Date();
			const subscriptions = this.userSubscriptions;
			if (subscriptions) {
				// eslint-disable-next-line camelcase
				const activeSubs = subscriptions.find(({ is_current_active }) => is_current_active);
				endDays = activeSubs && activeSubs.end_date ? activeSubs.end_date : '0';
				startDays = activeSubs && activeSubs.start_date ? activeSubs.start_date : '0';
				// end date
				let then = new Date(endDays);
				const dd1 = String(then.getDate()).padStart(2, '0');
				const mm1 = String(then.getMonth() + 1).padStart(2, '0');
				const yyyy1 = then.getFullYear();
				// eslint-disable-next-line
				then = mm1 + '/' + dd1 + '/' + yyyy1;
				const resultThen = new Date(then);
				const thenConvert = resultThen.getTime();
				// start date
				let start = new Date(startDays);
				const dd2 = String(start.getDate()).padStart(2, '0');
				const mm2 = String(start.getMonth() + 1).padStart(2, '0');
				const yyyy2 = start.getFullYear();
				// eslint-disable-next-line
				start = mm2 + '/' + dd2 + '/' + yyyy2;
				const resultStart = new Date(start);
				const startConvert = resultStart.getTime();
				// now
				let now = new Date();
				const dd3 = String(now.getDate()).padStart(2, '0');
				const mm3 = String(now.getMonth() + 1).padStart(2, '0');
				const yyyy3 = now.getFullYear();
				// eslint-disable-next-line
				now = mm3 + '/' + dd3 + '/' + yyyy3;
				const resultNow = new Date(now);
				const nowConvert = resultNow.getTime();
				// get on going days
				const onGoing = startConvert + nowConvert;
				// count start and end
				const sumSubs = startConvert + thenConvert;
				// diff with today
				const total = sumSubs - onGoing;
				const diffInDays = total / (1000 * 3600 * 24);
				return diffInDays;
			}
			return diffInDays;
		},
		isEndPeriod() {
			const subscriptions = this.userSubscriptions;
			let isPeriodEnd = false;
			if (subscriptions) {
				// eslint-disable-next-line camelcase
				const activeSubs = subscriptions.find(({ is_current_active }) => is_current_active);
				isPeriodEnd = activeSubs && activeSubs.is_cancel_end_period ? activeSubs.is_cancel_end_period : 0;
				return isPeriodEnd;
			}
			return isPeriodEnd;
		},
	},
	created() {
		if (this.user) {
			this.picture = this.user.picture;
			this.setProfileData();
			this.setPaymentData();
			this.setSettingsData();
			this.fetch();
		}
		this.paymentName = this.user && this.user.name ? this.user.name : '';
		this.paymentEmail = this.user && this.user.email ? this.user.email : '';
		dayjs.extend(relativeTime);
		if (this.$route.query.menu === 'general') this.tab = 'general';
	},
	watch: {
		user() {
			if (this.user) {
				this.picture = this.user.picture;
				this.setProfileData();
				this.setPaymentData();
			}
			this.setSettingsData();
		},
		name(val) {
			this.name = val.replace(/[^A-Z0-9 ]/gi, '');
		},
		activeToggleSubs() {
			if (this.activeToggleSubs === 'm') {
				this.filteredPackage = this.items.filter(item => (item.type === 'subscription' && !item.uid) && ((item.length === 30 && item.length_type === 'day') || (item.length === 1 && item.length_type === 'month')));
			}
			if (this.activeToggleSubs === 'y') {
				this.filteredPackage = this.items.filter(item => (item.type === 'subscription' && !item.uid) && ((item.length === 365 && item.length_type === 'day') || (item.length === 12 && item.length_type === 'month')));
			}
			if (this.activeToggleSubs === 'c') {
				this.filteredPackage = this.items.filter(item => (item.type === 'non_feature' || item.uid));
			}
		},
	},
};
</script>
